export default {
      id: "arrow_left-usage",
      viewBox: "0 0 10 18",
      url: __webpack_public_path__ + "img/icons.85006585.svg#arrow_left",
      toString: function () {
        return this.url;
      }
    }